import React from 'react'
import { BrowserRouter, Link, Route, Switch } from 'react-router-dom'
import {
  AppBar,
  Avatar,
  Button,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  withStyles
} from '@material-ui/core'
import LoginScreen from '../components/login'
import { connect } from 'react-redux'
import HomeIcon from '@material-ui/icons/Home'
import AssigmentIcon from '@material-ui/icons/Assignment'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import EjectIcon from '@material-ui/icons/Eject'
import MenuIcon from '@material-ui/icons/Menu'
import { logout, reLogin } from '../reducers/authorization'
// import { Alerts } from '@zadkiel/mui-redux-alerts'
import { schemaClientGet } from '../reducers/restApi'
import { PrivateRoute } from '../components/privateRoute'
import ArticleList from '../tabs/articleList'
import ArticleDetails from '../tabs/articleDetails'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import { withRouter } from 'react-router'

const styles = theme => ({
  button: {
    margin: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  flex: {
    flex: 1,
  },
  flexLeft: {
    // flex: 1,
  },
  myApps: {
    color: theme.palette.common.white,
  },
  text: {},
  icon: {},
  menuItem: {
    '&:focus': {
      background: theme.palette.primary[500],
      '& $text, & $icon': {
        color: theme.palette.common.white,
      },
    },
  },
  centeredTitle: {
    borderLeft: '0.1em solid white',
    padding: '0.5em',
    flex: 2,
  },
  hamburger: {
    marginRight: 20,

  },
  tooltip: {
    fontSize: theme.typography.fontSize * 1.5
  },
  userMenu: {
    top: 60
  },
  topMenu: {
    // width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: 0,
    padding: 0,
    textAlign: 'center',
    fontSize: 14,
    letterSpacing: '0.01em',
    height: 53,
    lineHeight: '53px',
    maxWidth: 900
  },
  topMenuLi: {
    color: 'black',
    textDecoration: 'none',
    display: 'inline-flex',
    margin: '0px 10px',
  },
  topMenuA: {
    color: 'black',
    textDecoration: 'none',
    fontSize: 'unset',
    textTransform: 'none',
  },
  topMenuDropdown: {
    color: 'black',
    fontSize: 14,
    textDecoration: 'none'
  },
  appBarStyle: {
    backgroundColor: 'white',
    // boxShadow: "0 7px 4px 0 rgba(0, 0, 0, 0.18)",
    // border: 'solid 1px #afafaf',
  }
})

class Home extends React.Component {
  render () {
    return <div> Select App </div>
  }
}

// TODO proper router-config implementation
const routes = [
  {
    // component: Root,
    routes: [
      {
        path: '/',
        exact: true,
        component: Home,
        title: 'Home',
        hidden: true,
        public: true
      },
      {
        path: '/tabs/home',
        component: Home,
        title: 'Home',
        icon: <HomeIcon/>,
        hidden: true,
        public: true
      },
      {
        path: '/tabs/article/:article_id',
        component: ArticleDetails,
        title: 'Article Details',
        icon: <AssigmentIcon/>,
        hidden: true,
        public: true
      },
      {
        path: '/tabs/article',
        component: ArticleList,
        title: 'Articles',
        icon: <AssigmentIcon/>,
        public: true
      },
    ]
  }
]

class SimpleMenu extends React.Component {
  state = {
    anchorEl: null,
    open: false,
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render () {
    let {
      classes,
      hasPerm,

      // ...props
    } = this.props
    let items = []

    for (let route of routes[0].routes) {
      if (!route.hidden && (!route.perm || hasPerm(route.perm) || route.public)) {
        items.push(
          <MenuItem key={route.path} className={classes.menuItem} onClick={this.handleClose}
                    component={Link} to={route.path}>

            <ListItemIcon className={classes.icon}>
              {route.icon}
            </ListItemIcon>
            <ListItemText inset primary={route.title}/>
          </MenuItem>
        )
      }
    }

    return (
      <div className={classes.flexLeft}>
        <Tooltip title="Apps" classes={{ tooltip: classes.tooltip }}>
          <Button
            aria-owns={this.state.open ? 'simple-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={classes.myApps}
          >
            <MenuIcon className={classes.hamburger}/>
          </Button>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleClose}
        >
          {items}
        </Menu>
      </div>
    )
  }
}

class UserMenu extends React.Component {
  state = {
    anchorEl: null,
    open: false,
  }

  handleClick = event => {
    this.setState({ open: true, anchorEl: event.currentTarget })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render () {
    let {
      classes, authorization, userLogout,
      // ...props
    } = this.props

    return (
      <div className={classes.flexLeft}>
        <Tooltip title="User Menu" classes={{ tooltip: classes.tooltip }}>
          <Button
            aria-owns={this.state.open ? 'user-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
            className={classes.myApps}
          >
            {authorization.user.profile.avatar ?
              <Avatar src={authorization.user.profile.avatar}/> :
              <Avatar>
                <AccountCircleIcon/>
              </Avatar>
            }
          </Button>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={this.state.anchorEl}
          open={this.state.open}
          onClose={this.handleClose}
          className={classes.userMenu}
        >
          <MenuItem key="logout" className={classes.menuItem} onClick={userLogout}>
            <ListItemIcon className={classes.icon}>
              <EjectIcon/>
            </ListItemIcon>
            <ListItemText inset primary="Logout"/>
          </MenuItem>
        </Menu>
      </div>
    )
  }
}

// const mapStateToProps = (state) => ({ alerts: state.alerts })
// const ConnectedAlerts = connect(mapStateToProps)(Alerts)

// const alertsStyle = {
//   position: 'fixed',
//   // transform: 'translate(-50%, 0px)',
//   top: 30,
//   right: 0,
//   zIndex: 1200,
// }

function titleFromLocation (location) {
  let searchPath = location.pathname
  if (searchPath.endsWith('/')) {
    searchPath = searchPath.slice(0, -1)
  }
  for (let pathObj of routes[0].routes) {
    if (pathObj.path === searchPath) {
      return pathObj.title
    }
  }
  return ''
}

class Router extends React.Component {
  state = {
    toolsMenuOpen: null
  }

  componentDidMount () {
    // TODO gather the schemas and login promises and show a loading screen
    this.props.reLogin(this.props.authorization)
    this.props.getSchema()
  }

  openToolsMenu = (event) => {
    this.setState({ toolsMenuOpen: event.currentTarget })
    console.log(event)
    event.preventDefault()

  }
  closeToolsMenu = () => {
    this.setState({ toolsMenuOpen: null })
  }

  render () {

    let {
      classes, authorization, userLogout,
      hasPerm,
      schema,
      location
      // ...props
    } = this.props

    let title = titleFromLocation(location)
    let privates = []
    for (let route of routes[0].routes) {
      if (route.public) {
        privates.push(
          <Route key={route.path} exact path={route.path} component={route.component}/>
        )
      } else {
        privates.push(
          <PrivateRoute key={route.path} exact path={route.path} authorization={authorization}
                        component={route.component} perms={route.perm}/>
        )
      }
    }
    // only show any components after schema loads and token is refreshed

    if (schema.error || schema.loading) {
      // TODO nicer loading screen
      return <div>
        loading...
      </div>
    }

    return (
      <div>
        <AppBar position="sticky">
          <Toolbar className={classes.appBarStyle}>
            {/*<Tooltip title={'Home'} classes={{ tooltip: classes.tooltip }}>*/}
            {/*<Button component={Link} to="/tabs/home/" label="Home">*/}
            {/*<HomeIcon/>*/}
            {/*</Button>*/}
            {/*</Tooltip>*/}

            <SimpleMenu className={classes.flex} classes={classes} hasPerm={hasPerm}/>

            <Typography className={classes.centeredTitle} variant="h6">
              {title}
            </Typography>

            <ul className={classes.topMenu}>
              <li className={classes.topMenuLi}><a className={classes.topMenuA} href="/">Home</a></li>
              <li className={classes.topMenuLi}><a className={classes.topMenuA} href="/about/">About</a></li>
              <li className={classes.topMenuLi}><a className={classes.topMenuA} href="/partners/">Partners</a></li>
              <li className={classes.topMenuLi}><a className={classes.topMenuA} href="/events/">Events</a></li>

              <li className={classes.topMenuLi}>
                <Button className={classes.topMenuA} onClick={this.openToolsMenu}>
                  Tools
                  <ArrowDropDownIcon/>
                </Button>
              </li>
              <Menu
                id="simple-menu"
                anchorEl={this.state.toolsMenuOpen}
                keepMounted
                open={Boolean(this.state.toolsMenuOpen)}
                onClose={this.closeToolsMenu}
              >
                <MenuItem className={classes.topMenuDropdown} href="/platform/tabs/article/"
                          onClick={this.closeToolsMenu}
                >Tools</MenuItem>
                <MenuItem className={classes.topMenuDropdown}
                          onClick={this.closeToolsMenu}>
                  <a className={classes.topMenuDropdown} href="/game/memory_gliders/">
                    Game
                  </a>
                </MenuItem>
              </Menu>

              <li className={classes.topMenuLi}><a className={classes.topMenuA} href="/in-media/">Press </a></li>
              <li className={classes.topMenuLi}><a className={classes.topMenuA}
                                                   href="/symposium-may-2019/">Symposium</a></li>
              <li className={classes.topMenuLi}><a className={classes.topMenuA} href="/contact/">Contact</a></li>
            </ul>
            {authorization.loggedIn &&
            <UserMenu classes={classes} authorization={authorization} userLogout={userLogout}/>
            }
          </Toolbar>
        </AppBar>

        {/*<ConnectedAlerts*/}
        {/*style={alertsStyle}/>*/}
        <Switch>
          <Route key="/login" path="/login" component={LoginScreen}/>
          {privates}
        </Switch>

      </div>
    )
  }
}

const mapState = (state, ownProps) => {
  return {
    authorization: state.authorization,
    // location: state.router.location.pathname,
    schema: state.schema,
    /** @namespace state.authorization.user.perms **/
    hasPerm: (perm) => !perm || (state.authorization.user.perms && state.authorization.user.perms.indexOf(perm) !== -1),
  }
}

const mapDispatch = dispatch => ({
  userLogout: logout(dispatch),
  reLogin: reLogin(dispatch),
  getSchema: () => dispatch(schemaClientGet()),

})

const InnerRouter = withStyles(styles)(withRouter(connect(mapState, mapDispatch)(Router)))

export default props => (
  // same as homepage i package.json and urls.py
  <BrowserRouter basename='/platform'>
    <InnerRouter/>
  </BrowserRouter>
)
